<template>
    <div
        :class="{
            'sw-text': true,
            [$style['price']]: true,
            [$style['price_bold']]: bold,
            [$style['price_bonus_credit']]: bonus === BONUS_TYPE.CREDIT,
            [$style['price_bonus_charge']]: bonus === BONUS_TYPE.CHARGE,
            [$style['price_large']]: large,
            [$style['price_inverted']]: inverted
        }"
    >
        <template v-if="currency && !bonus">
            {{ $n(value, { style: 'currency', currency: currency }) }}
        </template>

        <template v-else-if="bonus">
            <span v-if="bonusSign" :class="$style['price_bonus_sign']">
                <template v-if="bonus === BONUS_TYPE.CREDIT">+</template>
                <template v-if="bonus === BONUS_TYPE.CHARGE">-</template>
            </span>

            {{ value }}

            <SvgIconDiamond :class="$style['price_bonus_icon']" />
        </template>

        <template v-else>
            {{ value }}
        </template>
    </div>
</template>

<script>
import SvgIconDiamond from '@@/framework/icons/diamond.svg'
import { BONUS_TYPE } from '@@/framework/types'

export default {
  name: 'ProductPrice',
  components: { SvgIconDiamond },

  props: {
    value: {
      type: Number,
      default: 0
    },

    bold: {
      type: Boolean,
      default: false
    },

    bonus: {
      validator: value => [BONUS_TYPE.CHARGE, BONUS_TYPE.CREDIT, BONUS_TYPE.AVAILABLE, null].includes(value),
      default: null,
    },

    large: {
      type: Boolean,
      default: false
    },

    inverted: {
      type: Boolean,
      default: false
    },

    bonusSign: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    BONUS_TYPE: () => BONUS_TYPE,

    currency () {
      return this.$store.state.settings.default_currency
    },
  }
}
</script>

<style lang="less" module>
@import (reference) "~@omnica/base/assets/stylesheets/variables.less";

.price {
  font-size: 16px;
  font-variant: lining-nums;
  line-height: 24px;
  white-space: nowrap;

  &_bold {
    font-weight: 500;
  }

  &_bonus_icon {
    width: 20px;
    height: 20px;
    vertical-align: text-top;
    margin-left: -3px;
  }

  &_bonus_credit {
    color: @green-600;

    svg {
      fill: @green-600;
    }
  }

  &_bonus_charge {
    color: @red-500;

    svg {
      fill: @red-500;
    }
  }

  &_bonus_sign {
    margin-right: -3px;
  }

  &_large {
    font-size: 24px;
  }

  &_inverted {
    color: #FFFFFF;
  }
}
</style>
